import React, { useState, useEffect } from 'react';
import { Search, Globe, Server, X, Check } from 'lucide-react';
import { postData, getData } from '../../../../Services/Fetchnodeservices';

const ImageSearchModal = ({ isOpen, onClose, query, onSelect }) => {
    const [tab, setTab] = useState('web'); // web or server
    const [searchTerm, setSearchTerm] = useState(query);
    const [results, setResults] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (isOpen) {
            setSearchTerm(query);
            searchImages(query);
        }
    }, [isOpen, query, tab]);

    const searchImages = async (q) => {
        setLoading(true);
        try {
            // ये रूट आपके बैकएंड में Wikipedia या Google से इमेज लाएगा
            const endpoint = tab === 'web' ? "aimenu/search-web-images" : "aimenu/get-server-images";
            const response = await postData(endpoint, { query: q });
            if (response.success) setResults(response.images);
        } catch (e) { console.error(e); }
        finally { setLoading(false); }
    };

    if (!isOpen) return null;

    return (
        <div style={styles.overlay}>
            <div style={styles.modal}>
                <div style={styles.header}>
                    <h3>Find Image: {query}</h3>
                    <button onClick={onClose} style={styles.closeBtn}><X /></button>
                </div>

                <div style={styles.tabBar}>
                    <button onClick={() => setTab('server')} style={tab === 'server' ? styles.activeTab : styles.tab}>Self Server</button>
                    <button onClick={() => setTab('web')} style={tab === 'web' ? styles.activeTab : styles.tab}>Internet Search</button>
                </div>

                <div style={styles.searchBar}>
                    <input 
                        style={styles.input} 
                        value={searchTerm} 
                        onChange={(e) => setSearchTerm(e.target.value)} 
                    />
                    <button style={styles.searchBtn} onClick={() => searchImages(searchTerm)}><Search size={18} /></button>
                </div>

                <div style={styles.grid}>
                    {loading ? <p>Searching...</p> : results.map((img, i) => (
                        <div key={i} style={styles.card} onClick={() => onSelect(img.filename || img.url)}>
                            <img src={img.url.startsWith('http') ? img.url : `https://zaptodoor.com/upload/${img.url}`} style={styles.img} />
                            <div style={styles.imgLabel}>{img.name || "Select"}</div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

const styles = {
    overlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.9)', zIndex: 10000, display: 'flex', alignItems: 'center', justifyContent: 'center' },
    modal: { background: '#1e293b', width: '800px', borderRadius: '12px', padding: '20px', color: 'white' },
    header: { display: 'flex', justifyContent: 'space-between', marginBottom: '20px' },
    tabBar: { display: 'flex', gap: '10px', marginBottom: '15px', borderBottom: '1px solid #334155' },
    tab: { padding: '10px', background: 'transparent', color: '#94a3b8', border: 'none', cursor: 'pointer' },
    activeTab: { padding: '10px', background: 'transparent', color: '#a855f7', borderBottom: '2px solid #a855f7', cursor: 'pointer' },
    searchBar: { display: 'flex', gap: '10px', marginBottom: '20px' },
    input: { flex: 1, background: '#0f172a', border: '1px solid #334155', color: 'white', padding: '10px', borderRadius: '6px' },
    searchBtn: { background: '#3b82f6', border: 'none', color: 'white', padding: '0 15px', borderRadius: '6px' },
    grid: { display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '15px', maxHeight: '400px', overflowY: 'auto' },
    card: { background: '#0f172a', borderRadius: '8px', cursor: 'pointer', overflow: 'hidden', border: '1px solid #334155' },
    img: { width: '100%', height: '120px', objectFit: 'cover' },
    imgLabel: { fontSize: '10px', padding: '5px', textAlign: 'center', color: '#94a3b8' },
    closeBtn: { background: 'transparent', border: 'none', color: 'white' }
};

export default ImageSearchModal;